import { Box, Link, Typography, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useLocation } from 'react-router-dom';

import THEME from '../../constants/theme';

/**
 * Footer component with company information and copyright
 *
 * @returns {React.Component} FooterComponent
 */
const FooterComponent = () => {
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  // Don't render footer on specific pages
  if (
    location.pathname === '/' ||
    location.pathname === '/auth' ||
    location.pathname === '/contact'
  ) {
    return null;
  }

  return (
    <Box
      component='footer'
      sx={{
        width: '100%',
        overflowX: 'hidden',
        position: 'relative',
        zIndex: 5,
        py: { xs: 3, md: 4 },
        px: 0,
        mt: 4
      }}
    >
      <Box
        sx={{
          width: '100%',
          position: 'relative'
        }}
      >
        {/* Address and copyright content */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            maxWidth: { xs: '100%', sm: '60%' }
          }}
        >
          <Box>
            <Typography
              variant='body2'
              sx={{
                color: THEME.COLORS.NEUTRAL_BLACK,
                fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.SECONDARY,
                fontSize: '0.9rem',
                lineHeight: 1.5
              }}
            >
              Level 30, The Leadenhall Building, 122 Leadenhall Street,
            </Typography>
            <Typography
              variant='body2'
              sx={{
                color: THEME.COLORS.NEUTRAL_BLACK,
                mb: 0.5,
                fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.SECONDARY,
                fontSize: '0.9rem',
                lineHeight: 1.5
              }}
            >
              London EC3V 4AB, UK
            </Typography>
          </Box>

          <Typography
            variant='caption'
            sx={{
              color: THEME.COLORS.NEUTRAL_BLACK,
              opacity: 0.7,
              fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.SECONDARY,
              fontSize: '0.75rem'
            }}
          >
            {`COPYRIGHT © ${currentYear} MarQ Capital LTD ALL RIGHTS RESERVED`}
          </Typography>
        </Box>

        {/* LinkedIn icon - absolutely positioned relative to the container */}
        <IconButton
          component={Link}
          href='https://www.linkedin.com/company/mqcapital/'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='LinkedIn'
          sx={{
            color: THEME.COLORS.NEUTRAL_BLACK,
            padding: 0.5,
            position: { xs: 'static', sm: 'absolute' },
            left: { sm: '39%' }, // Position just after the text content
            top: { sm: '50%' },
            transform: { sm: 'translateY(-50%)' },
            marginTop: { xs: 2, sm: 0 }
          }}
        >
          <LinkedInIcon
            sx={{
              fontSize: { xs: '28px', sm: '30px' }
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
};

export default FooterComponent;
